import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { AgentList } from '../../../_models/agent.model';
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../../_services/app/notification.service';
import { AgentAdminService } from '../../../_services/api/agent-admin.service';
import { AdminUserService } from '../../../_services/api/admin-user.service';


@Component({
  selector: 'app-admin-agent-card',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './admin-agent-card.html',
  styleUrl: './admin-agent-card.scss',
})
export class AdminAgentCard implements OnInit, OnDestroy {
  @Input() agent!: AgentList;
  @Output() agentUpdated = new EventEmitter<void>();
  @Output() agentDeleted = new EventEmitter<void>();
  
  menuOpen = false;
  showDeleteModal = false;
  isUpdatingVisibility = false;

  constructor(
    private menuStateService: MenuStateService,
    private notification: NotificationService,
    private elementRef: ElementRef,
    private router: Router,
    private userService: AdminUserService,
    private agentService: AgentAdminService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.agent.id;
    });
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.agent.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }

  setDefaultImage(event: any): void {
    event.target.src = './assets/images/user-default.png';
  }

  toggleVisibility(): void {
    if (this.isUpdatingVisibility) return;
    
    this.isUpdatingVisibility = true;
    this.menuStateService.setActiveMenu(null);
    this.menuOpen = false;
    
    if (this.agent.isEnabled) {
      this.userService.disableUser(this.agent.id).subscribe({
        next: () => {
          this.agent.isEnabled = false;
          this.agentUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le agent est maintenant désactivé et n’a plus accès à la plateforme.");
        },
        error: (error) => {
          console.error('Error making agent disabled:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    } else {
      this.userService.enableUser(this.agent.id).subscribe({
        next: () => {
          this.agent.isEnabled = true;
          this.agentUpdated.emit();
          this.isUpdatingVisibility = false;
          this.notification.showSuccess("Le membre est maintenant actif et peut de nouveau accéder à la plateforme.");
        },
        error: (error) => {
          console.error('Error making member enabled:', error);
          this.isUpdatingVisibility = false;
          this.notification.showError('Erreur lors de la modification de la visibilité');
        }
      });
    }
  }

  details(){
    this.router.navigate(['/admin/agents/details', this.agent.id]);
  }

  edit(){
    this.router.navigate(['/admin/agents/edit', this.agent.id]);
  }

  confirmDelete(): void {
    this.menuOpen = false;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  deleteAgent(): void {
    this.agentService.deleteAgent(this.agent.id).subscribe({
      next: () => {
        this.showDeleteModal = false;
        this.agentDeleted.emit();
      },
      error: (error) => {
        console.error('Error deleting agent:', error);
        this.notification.showError('Erreur lors de la suppression du agent');
        this.showDeleteModal = false;
      }
    });
  }

  getStars(rating: number): string[] {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(i <= rating ? './assets/images/icons/star.png' : './assets/images/icons/empty-star.png');
    }
    return stars;
  }
}

